import { apiClient } from '@/api/client';
import { ENDPOINTS } from '@/api/endpoints';
import { SendNewMessageDto } from '@/api/requests/DTOS';

export const sendNewMessage = async (body: SendNewMessageDto) => {
  return await apiClient.post(ENDPOINTS.CHATS, body);
};
